import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './ContactPage.css';

const ContactPage = () => {
    const location = useLocation();
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (location.hash === '#contact-form') {
            // Small delay to let the page render fully before scrolling
            setTimeout(() => {
                const el = document.getElementById('contact-form');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formData = new FormData(formRef.current);
        // Optional identifier
        formData.append("form_type", "Prime Rehab Contact Form");

        try {
            const response = await fetch(
                "https://formsubmit.co/ajax/primerehaboffl@gmail.com",
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                    },
                    body: formData,
                }
            );

            if (response.ok) {
                alert("Thank you! Your inquiry has been submitted successfully.");
                formRef.current.reset();
            } else {
                alert("Something went wrong. Please try again.");
            }
        } catch (error) {
            console.error("Form submission error:", error);
            alert("Network error. Please try again later.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-page">
            <Navbar />

            {/* ── Hero Header ── */}
            <section className="contact-hero">
                <div className="contact-hero-container">
                    <div className="contact-hero-text">
                        <span className="section-subtitle">CONTACT US</span>
                        <h1 className="contact-hero-title">
                            Get in Touch With Our<br />
                            Equipment Specialists
                        </h1>
                    </div>
                    <div className="contact-hero-image">
                        <img
                            src="https://primerehabindustries.in/Image/Home/Contact.png"
                            alt="Physiotherapy Equipment"
                        />
                    </div>
                </div>
            </section>

            {/* ── Form + Info Panel ── */}
            <section className="contact-main-section" id="contact-form">
                <div className="contact-main-container">

                    {/* Left — Form */}
                    <div className="contact-form-side">
                        <h2 className="contact-form-heading">
                            Looking for Reliable<br />
                            Physiotherapy Equipment?
                        </h2>

                        <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
                            {/* FormSubmit Settings */}
                            <input type="hidden" name="_subject" value="New Inquiry - Prime Rehab" />
                            <input type="hidden" name="_template" value="table" />
                            <input type="hidden" name="_captcha" value="false" />

                            <div className="cf-field">
                                <label>Name</label>
                                <input type="text" name="name" placeholder="" required />
                            </div>
                            <div className="cf-field">
                                <label>Phone</label>
                                <input type="tel" name="phone" placeholder="" required />
                            </div>
                            <div className="cf-field">
                                <label>Email address</label>
                                <input type="email" name="email" placeholder="" required />
                            </div>
                            <div className="cf-field cf-field-textarea">
                                <label>Equipment Requirement</label>
                                <textarea name="requirement" rows="3" placeholder=""></textarea>
                            </div>
                            <button type="submit" className="contact-submit-btn" disabled={isSubmitting}>
                                {isSubmitting ? 'SENDING...' : 'REQUEST QUOTE'}
                            </button>
                        </form>
                    </div>

                    {/* Right — Contact Info */}
                    <div className="contact-info-side">
                        <div className="contact-info-item">
                            <div className="contact-info-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                    <circle cx="12" cy="10" r="3" />
                                </svg>
                            </div>
                            <div>
                                <p className="contact-info-label">ADDRESS:</p>
                                <p className="contact-info-value">
                                    Plot No: 4, Kandasamy Nagar Annex,<br />
                                    Vanagaram Chennai – 600095
                                </p>
                            </div>
                        </div>

                        <div className="contact-info-item">
                            <div className="contact-info-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.6a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                                </svg>
                            </div>
                            <div>
                                <p className="contact-info-label">PHONE:</p>
                                <a href="tel:+919994351947" className="contact-info-value contact-info-link">
                                    +91 9994351947
                                </a>
                            </div>
                        </div>

                        <div className="contact-info-item">
                            <div className="contact-info-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                    <polyline points="22,6 12,13 2,6" />
                                </svg>
                            </div>
                            <div>
                                <p className="contact-info-label">EMAIL:</p>
                                <a href="mailto:primerehabt1@gmail.com" className="contact-info-value contact-info-link">
                                    primerehaboffl@gmail.com
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* ── Google Map ── */}
            <section className="contact-map-section">
                <iframe
                    title="Prime Rehab Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.030788066547!2d80.13867!3d13.0720!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5261e3c7d6b4a7%3A0x6b8e5e2e5e5e5e5e!2sVanagaram%2C%20Chennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1709900000000!5m2!1sen!2sin"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </section>

            <Footer />
        </div>
    );
};

export default ContactPage;
